import { defineComponent as _defineComponent } from 'vue'
import { Heading, HeadingDisplay, Grid } from '@warrenbrasil/nebraska-web';
import { MainError } from '@/modules/trade/components/MainError';
import { MainLoading } from '@/modules/trade/components/MainLoading';
import { Money } from '@/modules/common/components/MoneyV2';
import { computed, onMounted, ref } from 'vue';
import {
  getAnnualProfit,
  ProfitAnnualData
} from '@/modules/wealth/services/portfolio';
import { AnnualProfitRow } from '../AnnualProfitRow';

interface Props {
  portfolioId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AnnualProfit',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
}



const isLoading = ref(false);
const hasError = ref(false);
const profitData = ref<ProfitAnnualData | null>(null);
const year = computed(() => String(profitData.value?.years[0].year));

const getProfitAnnualData = async () => {
  isLoading.value = true;
  hasError.value = false;

  try {
    profitData.value = await getAnnualProfit(props.portfolioId);
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};
onMounted(getProfitAnnualData);

return { __sfc: true,props, isLoading, hasError, profitData, year, getProfitAnnualData, Heading, HeadingDisplay, Grid, MainError, MainLoading, Money, AnnualProfitRow }
}

})